import { BaseTheme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function card(theme: BaseTheme): ComponentStyle {
  return {
    componentName: 'card',
    baseStyle: {
      padding: theme.space.s,
      border: 'none',
      position: 'relative',
      background: 'none',
      flex: '1',

      '&:after': {
        content: '""',
        position: 'absolute',
        borderRadius: theme.sizes['-1'],
        background: theme.colors.white25,
        inset: 0,
        zIndex: -450,
        mixBlendMode: 'overlay'
      },

      [`@media (max-width: ${theme.breakpoints[0]}px)`]: {
        padding: `${theme.space.m} ${theme.space.s}`
      }
    },
    variants: {
      eth: {
        '&:after': {
          background: `rgba(109, 124, 227, 0.5)
            radial-gradient(
              100% 333.15% at 0% 100%,
              rgba(255, 255, 255, 0) 0%,
              rgba(109, 124, 227, 0.2) 100%
          )`,
          mixBlendMode: 'lighten'
        }
      },
      mkr: {
        '&:after': {
          background: `rgba(26, 171, 155, 0.15)
            radial-gradient(
              100% 333.15% at 0% 100%,
              rgba(255, 255, 255, 0) 0%,
              rgba(26, 171, 155, 0.2) 100%
          )`,
          mixBlendMode: 'lighten'
        }
      },
      dai: {
        '&:after': {
          background: `rgba(251, 200, 84, 0.15)
            radial-gradient(
              100% 333.15% at 0% 100%,
              rgba(255, 255, 255, 0) 0%,
              rgba(251, 200, 84, 0.1) 100%
          )`,
          mixBlendMode: 'lighten'
        }
      },
      sdai: {
        '&:after': {
          background: `rgba(102, 187, 106, 0.15)
      radial-gradient(
        100% 333.15% at 0% 100%,
        rgba(255, 255, 255, 0) 0%,
        rgba(102, 187, 106, 0.1) 100%
    )`,
          mixBlendMode: 'lighten'
        }
      },

      usds: {
        '&:after': {
          background: `rgba(255, 139, 91, 0.15)
           radial-gradient(
            100% 333.15% at 0% 100%, 
            rgba(255, 255, 255, 0) 0%, 
            rgba(255, 139, 91, 0.1) 100%
          )`,
          mixBlendMode: 'lighten'
        }
      },
      susds: {
        '&:after': {
          background: `rgba(0, 245, 170, 0.15)
      radial-gradient(
        100% 333.15% at 0% 100%, 
        rgba(255, 255, 255, 0) 0%, 
        rgba(0, 204, 170, 0.05) 100%
      )`,
          mixBlendMode: 'lighten'
        }
      },
      sky: {
        '&:after': {
          background: `rgba(213, 110, 215, 0.15)
           radial-gradient(
            100% 333.15% at 0% 100%, 
            rgba(255, 255, 255, 0) 0%, 
            rgba(213, 110, 215, 0.1) 100%
          )`,
          mixBlendMode: 'lighten'
        }
      },
      usdc: {
        '&:after': {
          background: `rgba(39, 117, 202, 0.15)
           radial-gradient(
            100% 333.15% at 0% 100%, 
            rgba(255, 255, 255, 0) 0%, 
            rgba(39, 117, 202, 0.1) 100%
          )`,
          mixBlendMode: 'lighten'
        }
      },
      linkCardKpi: {
        '&:after': {
          background: 'none',
          mixBlendMode: 'lighten'
        }
      },
      linkCard: {
        padding: 'unset'
      },
      linkCardInset: {},
      stusds: {
        '&:after': {
          background: `rgba(187, 92, 189, 0.15)
           radial-gradient(
            100% 333.15% at 0% 100%, 
            rgba(255, 255, 255, 0) 0%, 
            rgba(187, 92, 189, 0.1) 100%
          )`,
          mixBlendMode: 'lighten'
        }
      }
    }
  };
}
